export default __webpack_public_path__ + "static/media/green_olive.6b22a652.png";